import { trackPageLoad } from "@asosteam/asos-content-web-analytics";
import sdkProvider from "../helpers/sdk-provider";
import analyticsProvider from "./analyticsProvider";
import getUserLoginStatus from "./getUserLoginStatus";
import { getPremierAnalytics } from "./premierAnalyticsValues";

export const trackPageEvent = async () => {
  try {
    const identity = await sdkProvider("identity");
    const isAuthenticated = await identity.customer.isAuthenticated();
    const isRecognised = (await identity.customer.isRecognised?.()) || false;
    const customerId = await identity.customer.customerId();
    const { platform = "", storeId = "" } =
      window.asos.webContext.getWebContext();
    const server = `${platform} ${storeId.toLowerCase()}`;
    const pageLoadProperties = {
      server,
      customerId: customerId,
      loginStatus: getUserLoginStatus({ isAuthenticated, isRecognised }),
      eVar141: await getPremierAnalytics(),
    };
    const config = analyticsProvider("page-load", pageLoadProperties);
    await trackPageLoad(config);
  } catch (e) {
    throw new Error(e);
  }
};
